import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import PendingActionsCard from "./PendingActionsCard";
import { useSelector } from "react-redux";

export default function PendingActions(props) {
  const state = useSelector((state) => state.dashboard);
  const { isLoading, drawerOpen, approvalStats } = state;
  const { scenarioCount, quotaCount, quotaModificationsCount } = approvalStats;
  const selectedCountryID = props.selectedCountryID;


  return (
    <>
      <Box
        sx={{
          width: drawerOpen ? "30vw" : "100%",
          p: 1,
          visibility:isLoading ? "hidden":"visible" 
        }}
      >
        <Typography
          sx={{
            mt: 5,
          }}
          variant="subtitle1"
        >
          Pending Actions
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "10px",
            mt: 2,
            fontWeight: 500,
          }}
        >
          <PendingActionsCard
            text={"Scenario Pending for Approval"}
            number={scenarioCount}
            redirectionUrl={"/approval/scenario"}
            isNavigate={"scenario"}
            selectedCountryID={selectedCountryID}
            link="/approval/scenario"
          />
          <PendingActionsCard
            text={"Quota Pending for Approval"}
            number={quotaCount}
            redirectionUrl={"/approval/quota"}
            isNavigate={"quota"}
            selectedCountryID={selectedCountryID}
            link="/approval/quota"
          />
          <PendingActionsCard
            text={"Quota Modification Pending for Approval"}
            number={quotaModificationsCount}
            redirectionUrl={"/approval/quota-modification"}
            isNavigate={"quota-modification"}
            selectedCountryID={selectedCountryID}
            link="/approval/quota-modification"
          />
        </Box>
      </Box>
    </>
  );
}
